<ng-container *ngIf="warranty">
  <a [routerLink]="{ cxRoute: 'product', params: warranty } | cxUrl" [queryParams]="{gaListName: gaListName}">
    <cx-media class="warranty-image" [container]="warranty.images?.PRIMARY" format="product"
      [alt]="warranty.name || warranty.summary"></cx-media>
  </a>
  <div class="description">
    <a [routerLink]="{ cxRoute: 'product', params: warranty } | cxUrl" [queryParams]="{gaListName: gaListName}">
      <span class="name">{{ warranty.name }}</span>
    </a>
    <div class="price" *ngIf="warranty.purchasable">
      {{ warranty.price?.formattedValue }}
      <span class="price-label">MSRP</span>
      <gen-info-price-wrapper [product]="warranty" [position]="TooltipPosition.Right"></gen-info-price-wrapper>
    </div>
    <div *ngIf="!warranty.purchasable" class="cx-product-price-container non-price">
      <div class="position-relative" (mouseenter)="callForPricingMessage=tooltipMessage"
        (mouseleave)="callForPricingMessage=''">
        <a [href]="contactForPricingHref" class="call-for-pricing link cx-action-btn-link">
          Contact For Pricing
          <gen-info-message [message]="callForPricingMessage" [position]="'position-right'"></gen-info-message>
        </a>
      </div>
    </div>
  </div>
  <gen-add-to-cart *ngIf="warranty.purchasable" [product]="warranty" [purchasable]="true" [productCode]="warranty.code"
    [showQuantity]="false" [gaListName]="gaListName" [isIcon]="true"></gen-add-to-cart>
</ng-container>